"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFundingFeeRecord = void 0;
const RecordApi_1 = require("../../apis/RecordApi");
const usePullRefresh_1 = require("../../hooks/usePullRefresh");
/**查询资金费记录 */
function useFundingFeeRecord(props) {
    const { filterParams, accountType } = props;
    return (0, usePullRefresh_1.usePullRefresh)({
        query: RecordApi_1.queryFundingFeeRecord,
        getLoadMoreParams: (source) => {
            if (!source.length) {
                return undefined;
            }
            return { page_cursor: source[source.length - 1].next_page_cursor };
        },
        filterParams,
        pageLimit: 10,
        accountType,
    });
}
exports.useFundingFeeRecord = useFundingFeeRecord;
